module.exports = __webpack_public_path__ + "static/media/um.03f4ea44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/um.png
// module id = 2010
// module chunks = 0